export default __webpack_public_path__ + "static/media/IconTooltip.e465b587.svg";